/* Text.tsx
   Version: 1.0.0
   Date: 2020-11-28
*/

// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

export interface TextProps {
    children?: React.ReactNode,
    className?: string;
}

const Text: React.FC<TextProps> = (props): JSX.Element => {

    Text.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    }
    
    
    return(
        <span className={props.className ?? 'basic-text'}>{props.children}</span>
    );

}

export default Text;
